import { render } from "./Dashboard.vue?vue&type=template&id=eb8f5650"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=eb8f5650&lang=scss"
script.render = render

export default script